import { render, staticRenderFns } from "./FrmLibroAtencion.vue?vue&type=template&id=fc58bed8&"
import script from "./FrmLibroAtencion.vue?vue&type=script&lang=js&"
export * from "./FrmLibroAtencion.vue?vue&type=script&lang=js&"
import style0 from "./FrmLibroAtencion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports